<template>
  <div>
    <div class="section-container">
      <div class="section"
          v-for="(section, sectionIndex) in sections"
          :key="section.title">
        <h3 class="section-title" :id="section.title">{{ section.title }}</h3>
        <div class="piece-list">
          <piece
            :piece="piece"
            :img-prefix="imgPrefix"
            @click.native="selectPiece(sectionIndex, pieceIndex)"
            v-for="(piece, pieceIndex) in section.pieces"
            :key="piece.url"
          ></piece>
        </div>
      </div>
    </div>
    <modal
      v-if="selected"
      :urlPrefix="imgPrefix"
      :piece="sections[selected.section].pieces[selected.piece]"
      @close="selected = null"
      ></modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import PieceComponent from './Piece';

const piecesUrl = 'https://s3.amazonaws.com/marcia-pottery/pieces.json';
export default {
  components: {
    piece: PieceComponent,
  },
  computed: mapState({
    token: state => state.auth.authToken,
  }),
  data() {
    return {
      selected: null,
      imgPrefix: 'https://s3.amazonaws.com/marcia-pottery/images/',
      sections: [],
    };
  },
  methods: {
    ...mapActions([]),
    selectPiece(sectionIndex, pieceIndex) {
      this.selected = {
        section: sectionIndex,
        piece: pieceIndex,
      };
    },
    // onPieceDragStart(id) {
    //   // eslint-disable-next-line
    //   console.log('started dragging piece:', id);
    // },
  },
  mounted() {
    axios({
      method: 'get',
      url: piecesUrl,
    }).then(res => {
      // console.log(res);
      this.sections = res.data.sections;
    });
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GalleryEdit.vue?00fc911e